/*
  Szablon roboczy: rozwijana lista wariantów w pakietach, jak w Kaching Bundles.
  Pokazuje kropkę z kolorem (próbka z Shopify) albo miniaturę wariantu obok nazwy.
  Oryginalny <select> zostaje ukryty i dalej steruje motywem (zmiana wywołuje zdarzenie change).
*/
(function () {
  function swatchHTML(opt) {
    if (!opt) return '';
    var color = opt.getAttribute('data-swatch');
    var img = opt.getAttribute('data-swatch-img');
    if (color) return '<span class="qb-dd__dot" style="background:' + color + '"></span>';
    if (img) return '<span class="qb-dd__dot qb-dd__dot--img" style="background-image:url(' + img + ')"></span>';
    // Nazwa wariantu będąca kolorem CSS (np. „Red”, „Navy”) też dostaje kropkę
    var name = (opt.text || '').trim().toLowerCase().replace(/\s+/g, '');
    if (opt.getAttribute('data-color') === 'true' && name && window.CSS && CSS.supports && CSS.supports('color', name)) {
      return '<span class="qb-dd__dot" style="background:' + name + '"></span>';
    }
    return '';
  }

  function closeAll(except) {
    document.querySelectorAll('.qb-dd.is-open').forEach(function (dd) {
      if (dd !== except) dd.classList.remove('is-open');
    });
  }

  function enhance(select) {
    if (select.dataset.qbDd) return;
    select.dataset.qbDd = '1';

    var dd = document.createElement('div');
    dd.className = 'qb-dd';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'qb-dd__btn';
    var menu = document.createElement('div');
    menu.className = 'qb-dd__menu';

    function render() {
      var cur = select.options[select.selectedIndex];
      btn.innerHTML = swatchHTML(cur) + '<span class="qb-dd__label">' + (cur ? cur.text : '') + '</span>' +
        '<svg class="qb-dd__caret" viewBox="0 0 10 6" aria-hidden="true"><path d="M0 0l5 6 5-6z" fill="currentColor"/></svg>';
      menu.querySelectorAll('.qb-dd__item').forEach(function (it, i) {
        it.classList.toggle('is-selected', i === select.selectedIndex);
      });
    }

    Array.prototype.forEach.call(select.options, function (opt, i) {
      var it = document.createElement('button');
      it.type = 'button';
      it.className = 'qb-dd__item';
      it.innerHTML = swatchHTML(opt) + '<span>' + opt.text + '</span>';
      it.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        select.selectedIndex = i;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        dd.classList.remove('is-open');
        render();
      });
      menu.appendChild(it);
    });

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      closeAll(dd);
      dd.classList.toggle('is-open');
    });
    select.addEventListener('change', render);

    dd.appendChild(btn);
    dd.appendChild(menu);
    select.classList.add('qb-dd__native');
    select.parentNode.insertBefore(dd, select.nextSibling);
    render();
  }

  function init(root) {
    (root || document).querySelectorAll('select.quantity-break-variant-select').forEach(enhance);
  }

  document.addEventListener('click', function () { closeAll(null); });

  // Przyklejony pasek: cena wybranego pakietu pod nazwą produktu (jak w Shrine), brana z głównego przycisku
  function syncStickyPrice() {
    var src = document.querySelector('.shop-add-to-cart-button .button-text');
    var det = document.querySelector('#stickyAddToCart .desktop-view .sticky-add-to-cart__details');
    if (!src || !det) return;
    var el = det.querySelector('.sr-sticky-price');
    if (!el) { el = document.createElement('div'); el.className = 'sr-sticky-price'; det.appendChild(el); }
    var now = src.querySelector('.atc-price');
    var cmp = src.querySelector('s');
    var html = (now ? '<span class="sr-sticky-price__now">' + now.textContent + '</span>' : '') +
      (cmp ? '<s class="sr-sticky-price__was">' + cmp.textContent + '</s>' : '');
    if (el.innerHTML !== html) el.innerHTML = html;
  }
  function watchStickyPrice() {
    var src = document.querySelector('.shop-add-to-cart-button');
    if (!src || src.dataset.srWatch) return;
    src.dataset.srWatch = '1';
    new MutationObserver(syncStickyPrice).observe(src, { childList: true, subtree: true, characterData: true });
    syncStickyPrice();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchStickyPrice);
  } else {
    watchStickyPrice();
  }
  window.addEventListener('load', function () { watchStickyPrice(); syncStickyPrice(); });

  // Ocena przy nagłówku produktu: płynne przewinięcie do sekcji z opiniami
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('.imgr-container, .imgr-link');
    if (!link) return;
    var target = document.querySelector('.sr-op') || document.querySelector('[id*="sr_opinie"]');
    if (!target) return;
    e.preventDefault();
    var header = document.querySelector('.header-wrapper');
    var offset = header ? header.offsetHeight + 10 : 10;
    window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - offset, behavior: 'smooth' });
  });

  // Przyklejony pasek „Add to cart” klika główny przycisk, żeby do koszyka trafił wybrany pakiet (ilość i warianty)
  document.addEventListener('click', function (e) {
    var stickyBtn = e.target.closest && e.target.closest('.sticky-add-to-cart button');
    if (!stickyBtn) return;
    var mainBtn = document.querySelector('.shop-add-to-cart-button');
    if (!mainBtn || !document.querySelector('.quantity-break-container')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    mainBtn.click();
  }, true);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  new MutationObserver(function () { init(); }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Szablon roboczy: przycisk „do góry” (jak w Shrine), pojawia się po przewinięciu */
(function () {
  function init() {
    if (document.querySelector('.sr-top')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'sr-top';
    b.setAttribute('aria-label', 'Back to top');
    b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 15l6-6 6 6"/></svg>';
    b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    document.body.appendChild(b);
    function update() {
      b.classList.toggle('is-visible', window.pageYOffset > 700);
      var sticky = document.querySelector('#stickyAddToCart .sticky-add-to-cart.show, #stickyAddToCart.show');
      var h = sticky ? sticky.getBoundingClientRect().height : 0;
      b.style.bottom = (h > 0 && sticky.getBoundingClientRect().top < window.innerHeight ? h + 14 : 20) + 'px';
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
